import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: "What if it doesn't work for me?",
    a: 'You have a full 7-day guarantee. No questions asked. The risk is zero.'
  }, {
    q: "It's just a PDF — how different can it be?",
    a: "It's not motivation. It's a specific sequence for a specific moment. That actually changes behavior."
  }, {
    q: "Shouldn't I see a doctor first?",
    a: "If you have medical concerns, yes. This guide is for the mental component, not the physical one. They're different things."
  }, {
    q: "I've already tried things and they didn't work.",
    a: "What you tried didn't have the right mechanism. Spectatoring isn't solved with generic advice."
  }, {
    q: 'Is it private?',
    a: "100%. Direct download. It won't show up on your bank statement with a compromising name."
  }];
  return <section className="py-20 md:py-24 px-4 sm:px-6 bg-dark-card/30 border-t border-dark-border" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-text-primary" data-id="element-60">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, index) => <div key={index} className="bg-dark-bg border border-dark-border rounded-lg overflow-hidden" data-id="element-62">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-63">
                <span className="font-bold text-text-primary pr-4" data-id="element-64">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-65" />
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-66">
                <p className="text-text-secondary leading-relaxed" data-id="element-67">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}